import authentication from '../middleware/authentication'
const Index = () => import(/* webpackChunkName: "static/js/chunks/manageEndCallStatus" */'../../views/ManageEndCallStatus/index')

const manageEndCallStatusRoutes = {
  path: '/manage-end-call-status',
  name: 'ManageEndCallStatus',
  component: Index,
  meta: {
    middleware: authentication,
    layout: 'main',
    pageTitle: '後作業自動切替'
  }
}

export default manageEndCallStatusRoutes
